import {useContext, useEffect, useState} from "react";

import {useQuery} from "@tanstack/react-query";
import ChooseYourLookModified from "../main/ChooseYourLookModified";
import {chooseYourLook} from "../../api/page";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";


export default function TestPage() {
	const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

	const {data: chooseYourLookItems} = useQuery({
		queryKey: ['page', 'choose-your-look', !!state.customer?.id],
		queryFn: () => chooseYourLook(!!state.customer?.id)
	})

	return (<main className="main-404">
			<section className="page-404 pt">
				<div className="page-404__wrap">
					<h4 className="f-exp">
						Test page
					</h4>
				</div>
				{chooseYourLookItems?.length && <ChooseYourLookModified items={chooseYourLookItems}/>}

			</section>
		</main>
	)
}